import React from 'react';
import linkIcon from '../../../img/icons/linkIcon.svg';
import style from './style.module.less';

function LinkTableComponent({ link }) {
  return (
    <div>
      <a href={link} target="_blank" rel="noreferrer">
        <img src={linkIcon} width={16} height={16} />
      </a>
    </div>
  );
}

export default LinkTableComponent;
